<template>
    <van-popup class="report-act-remind-popup-box" v-bind:value="showReportActRemindPopup" v-bind:close-on-click-overlay="false">
        <div class="report-act-popup-close" @click="clickClose"><span class="close"></span></div>
        <div class="report-act-remind-popup">
            <div v-if="reportAIData.describe_short && reportAIData.describe_short.length > 0" class="report-act-remind-pp-content">
                <p v-for="dContent in reportAIData.describe_short">{{ dContent }}</p>
            </div>
            <div class="report-act-remind-pp-btn-box">
                <button class="report-act-pp-btn" @click="clickReportActButton('')"><i class="iconfont icon-key"></i>限时特惠{{ ( showFreeCharacter ? '解锁天赋能力' : '解锁两项分析' ) + reportActCountTime1 }}</button>
                <div class="report-act-remind-pp-btn-text">原价{{ reportActProductGiftData ? reportActProductGiftData.rate_price : '18' }}元，仅此一次{{ reportActProductGiftData ? reportActProductGiftData.price : '6' }}元解锁</div>
                <div class="report-act-remind-pp-btn-text line2" v-if="reportProductData['pay_10005']">
                    <span class="span-underline" @click="clickReportActButton('pay_10005')">{{reportProductData['pay_10005'].price}}元解锁全部报告</span>
                    <span class="span-through">原价{{reportProductData['pay_10005'].rate_price}}</span>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config'
import { MIX } from '../../modules/utils';
export default {
    name: 'ReportActRemindPopup',
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        showFreeCharacter() {
            return this.$store.state.report.showFreeCharacter;
        },
        showReportActRemindPopup() {
            return this.$store.state.report.showReportActRemindPopup
        },
        reportActCountTime1() {
            return this.$store.state.report.reportActCountTime1;
        },
        reportAIData() {
            return this.$store.state.report.reportAIData;
        },
        reportActProductGiftData() {
            return this.$store.state.report.reportActProductGiftData;
        },
        reportProductData() {
            return this.$store.state.pay.reportProductData;
        },
    },
    mounted() {
        setTimeout(() => {
            MIX.trackPageViewed('DifferencePriceOnlyOneChanceCenterPage');
        }, 20);
    },
    methods: {
        clickClose() {
            // 隐藏弹框
            this.$store.state.report.showReportActRemindPopup = false;
            // 显示悬浮按钮、开始跑倒计时
            this.$store.state.report.showReportActBtn = true;
            this.$store.dispatch('report/runReportAICount');
        },
        clickReportActButton(pid) {
            let productData = pid == 'pay_10005' ? this.$store.state.pay.reportProductData['pay_10005'] : this.reportActProductGiftData;
            let detailInfo = this.$store.state.report.detailInfo;
            var payType = CONFIG.platform == 'qq' ? 'wx_qr' : 'wx_pub';
            console.log('clickReportActButton-----', productData, detailInfo, payType);

            if(detailInfo == null || productData == null) {
                this.$toast('商品出错，请刷新稍后再试')
                return;
            }
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: productData.pid,              //支付项目id
                    ptype: payType,                    //支付方式
                    ext: detailInfo.id                 //支付的评测id
                },
                mixParams: {
                    pid: productData.pid,
                    product_name: productData.title,
                    price: productData.price,
                    from: 'price_only_one_chance',
                },
                sucCb: () => {
                    console.log('支付成功，更新测评报告数据');
                    this.$store.dispatch('report/updateReportShowTimeAndActData');
                    // 更新测验报告数据
                    if(detailInfo) {
                        this.$store.dispatch('report/updateReportInfo', detailInfo.id);
                    }
                    // 更新ai状态
                    this.$store.state.detail.personInfo.ai = 1;
                    this.$store.dispatch('record/updateRecordListAIStatus', {
                        id: detailInfo.id
                    });

                }
            });
        },
    }
}
</script>
